import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

    connect(): void {

        this.waitForTomSelect();
    }

    private waitForTomSelect(): void {

        const interval = setInterval(() => {

            const tomSelect = (this.element as any).tomselect;

            if (!tomSelect) {
                return;
            }

            clearInterval(interval);

            // =====================================
            // ITEM RENDER
            // =====================================

            tomSelect.settings.render.item = (
                data: any,
                escape: any
            ) => {

                const color =
                    data.color || this.resolveColor(data.text);

                return `
                    <div
                        class="
                            badge
                            bg-${color}
                            text-white
                            fs-6
                            px-2
                            py-2
                            ms-1
                            d-inline-flex
                            align-items-center
                        "
                    >

                        <span>
                            ${escape(data.text)}
                        </span>

                        <span
                            class="custom-remove ms-2 me-1"
                            data-value="${escape(data.value)}"
                            style="
                                cursor:pointer;
                                font-weight:bold;
                                color:white;
                            "
                        >
                            &times;
                        </span>

                    </div>
                `;
            };

            // =====================================
            // OPTION RENDER
            // =====================================

            tomSelect.settings.render.option = (
                data: any,
                escape: any
            ) => {

                const color =
                    data.color || this.resolveColor(data.text);

                return `
                    <div class="py-1">

                        <span
                            class="
                                badge
                                bg-${color}
                                text-white
                                fs-6
                                px-2
                                py-1
                                me-1
                            "
                        >
                            ${escape(data.text)}
                        </span>

                    </div>
                `;
            };

            // =====================================
            // REFRESH — clear cache first so new
            // render functions are actually used
            // =====================================

            if (typeof tomSelect.clearCache === 'function') {
                tomSelect.clearCache();
            } else {
                // Fallback: clear internal caches directly
                tomSelect.renderCache = {};
            }

            tomSelect.refreshOptions(false);
            tomSelect.refreshItems();

            // =====================================
            // REMOVE BUTTON
            // =====================================

            tomSelect.control.addEventListener(
                'click',
                (e: any) => {

                    const button =
                        e.target.closest('.custom-remove');

                    if (!button) {
                        return;
                    }

                    e.preventDefault();

                    e.stopPropagation();

                    const value =
                        button.dataset.value;

                    if (!value) {
                        return;
                    }

                    tomSelect.removeItem(value);
                }
            );

        }, 100);
    }

    private resolveColor(
        text: string
    ): string {

        text = text.toUpperCase();

        // =====================================
        // GROUP
        // =====================================

        if (
            text.includes('[GROUP]')
            || text.includes('[GRUPO]')
            || text.includes('GROUP:')
            || text.includes('GRUPO:')
            || text.startsWith('GROUP ')
            || text.startsWith('GRUPO ')
        ) {
            return 'success';
        }

        // =====================================
        // TELEFONERO
        // =====================================

        if (
            text.includes('[TELEFONERO]')
            || text.includes('TELEFONERO:')
            || text.startsWith('TELEFONERO ')
        ) {
            return 'primary';
        }

        // =====================================
        // ROUTE
        // =====================================

        if (
            text.includes('[ROUTE]')
            || text.includes('[RUTA]')
            || text.includes('ROUTE:')
            || text.includes('RUTA:')
            || text.startsWith('ROUTE ')
            || text.startsWith('RUTA ')
        ) {
            return 'warning';
        }

        // =====================================
        // COURSE
        // =====================================

        if (
            text.includes('[COURSE]')
            || text.includes('[CURSO]')
            || text.includes('COURSE:')
            || text.includes('CURSO:')
            || text.startsWith('COURSE ')
            || text.startsWith('CURSO ')
        ) {
            return 'info';
        }

        // =====================================
        // CHILD TYPE
        // =====================================

        if (
            text.includes('[CHILD_TYPE]')
            || text.includes('[TIPO REGISTRO]')
            || text.includes('CHILD_TYPE:')
            || text.includes('TIPO REGISTRO:')
        ) {
            return 'secondary';
        }

        // =====================================
        // SCHEDULE
        // =====================================

        if (
            text.includes('[VIERNES]')
            || text.includes('[SABADO]')
            || text.includes('[DOMINGO]')
            || text.includes('HORARIO:')
            || text.startsWith('HORARIO ')
        ) {
            return 'dark';
        }

        if (
            text.includes('ASISTENCIA')
            || text.includes('ASISTENCIA:')
        ) {
            return 'danger';
        }


        // =====================================
        // LIBRES
        // =====================================

        return 'secondary';
    }
}
